function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}
import api from "../../../utils/api";
import { RequestParams } from "../../../utils/RequestParams";



const get = async (headers) => {
  try {
    const requestParams = new RequestParams({}, headers);
    const response = await api.get('templates', requestParams);
    return response.json.rows;
  } catch (e) {
    return e;
  }
};

const setDefault = async (requestParams) => {
  const response = await api.post('templates/setasdefault', requestParams);
  return response;
};

const remove = async (requestParams) => {
  const response = await api.delete('templates', requestParams);
  return response.json;
};

const checkTemplatesEntityCount = async (
headers,
templateIds) =>
{
  if (!templateIds || !Array.isArray(templateIds) || templateIds.length === 0) return {};
  const counts = await Promise.all(
    templateIds.map(async (id) => {
      const requestParams = new RequestParams({}, headers);
      const response = await api.get(
        `v2/entities/count_by_template?templateId=${id}`,
        requestParams
      );
      return { id, count: response.json };
    })
  );
  return counts.reduce((acc, { id, count }) => _objectSpread(_objectSpread({}, acc), {}, { [id]: count }), {});
};

const save = async (template) => {
  const requestParams = new RequestParams(template);
  const response = await api.post('templates', requestParams);
  return response.json;
};

export { get, setDefault, remove, checkTemplatesEntityCount, save };